import { render, staticRenderFns } from "./ArticleList.vue?vue&type=template&id=dd400516&scoped=true"
import script from "./ArticleList.vue?vue&type=script&lang=js"
export * from "./ArticleList.vue?vue&type=script&lang=js"
import style0 from "./ArticleList.vue?vue&type=style&index=0&id=dd400516&prod&lang=scss&scoped=true"
import style1 from "./ArticleList.vue?vue&type=style&index=1&id=dd400516&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd400516",
  null
  
)

export default component.exports